import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import AreaExposicao from '../AreaExposicao';
import AreaInstitucional from '../AreaInstitucional';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';
import { scrollTo } from '../../components/Menu';
import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';


import Publicas from './modules/publicas';

import { usePages } from '../../hooks/Pages';

import SponsorsList from '../Sponsors';
import Program from '../Program';
import Youtube from '../../components/Youtube';
import Speakers from '../Speakers';
import Sobre from '../Sobre';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {



  return (
    <>
      <Capa style={{minHeight: '30vh', paddingTop:'100px'}}>
        <div className="p50" style={{marginTop: '30px', alignItems:'flex-start', maxWidth:'400px', minWidth:'auto'}}>

          <h1 style={{maxWidth: '400px'}}>Ensino de ética nos cursos de Engenharia Civil e de Arquitetura e Urbanismo</h1>
          <h2 style={{maxWidth: '400px', margin: '20px 0px',  background: '#fff', textAlign: 'left', padding: '10px', color: '#005da5', fontSize: '18px'}}>17, 19, 24 e 26 de maio de 2022</h2>
          <p style={{marginBottom: '20px'}}>Evento online | Faça sua inscrição</p>
 
        </div>



        <div  style={{maxWidth: '500px', width: '100%', display: 'flex', alignItems: 'center', justifyContent:'center', flexDirection:'column'}}>

          <div
            className=""
            style={{
              width: '100%',

              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {' '}

            <Link className="" to="/inscricao">
              <Button type="button">Inscreva-se</Button>
{' '}
            </Link>

            <Link className="" to="/login">
              <Button type="button">Acesse</Button>

              {' '}
            </Link>
          
            <Link className="" to="/certificados">
              <Button type="button">Certificados</Button>

              {' '}
            </Link>
          </div>
        <Whatsapp message='Suporte técnico' number='5551981228839' text='Estou no Ensino de ética nos cursos de Engenharia Civil e de Arquitetura e Urbanismo'/>
        
        </div>
      </Capa>
      <SponsorsList/>
      <br/><br/>
      <Capa id="programacao" style={{background: '#fff'}}>
      <Program/>
      </Capa>
      
      
<Speakers/>
 
 <Sobre/>
    
    </>
  );
};
export default Home;
